import { Box, Button, Stack, TextField } from '@mui/material';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../../store/actions/GlobalActions';
import { notEmpty, validPassword } from '../../util/Validation';
import { selectRegistrationRequest, selectRole } from '../../store/selectors/GlobalSelector';
import axios from '../../util/Axios';
import { useTranslation } from 'react-i18next';

export function ChoosePassword() {
  const { t } = useTranslation();
  const registrationRequest = useSelector(selectRegistrationRequest);
  const role = useSelector(selectRole);

  const selectedPassword = useSelector((state) => state.GlobalReducer.registrationInfo.password);
  const [password, setPassword] = useState(selectedPassword);
  const [repeatedPassword, setRepeadetPassword] = useState(selectedPassword);

  const dispatch = useDispatch();
  const handleNext = () => {
    dispatch({ type: actions.CHOOSE_PASSWORD, payload: password });
    if (role === 'LEGAL_TEAM') {
      registerLegal();
    } else {
      dispatch({ type: actions.NEXT_REGISTRATION_STEP });
    }
  };

  const handleBack = () => {
    dispatch({ type: actions.PREVIOUS_REGISTRATION_STEP });
  };

  const passwordDoNotMatch = () => {
    if (repeatedPassword === '') {
      return false;
    }
    return password !== repeatedPassword;
  };

  const registerLegal = () => {
    const request = { ...registrationRequest };

    axios.post(`users/legalAdmin`, request).then((resp) => {
      dispatch({ type: actions.FINISH_REGISTRATION_LEGAL_TEAM });
    });
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 5 }}>
      <TextField type="password" helperText={t('password_help')} error={!validPassword(password)} value={password} onChange={(event) => setPassword(event.target.value)} label={t('enter_password')}></TextField>
      <TextField type="password" error={passwordDoNotMatch()} helperText={passwordDoNotMatch() ? t('password_mismatch') : ''} required value={repeatedPassword} onChange={(event) => setRepeadetPassword(event.target.value)} label={t('repeat_password')}></TextField>
      <Stack direction="row" sx={{ marginTop: 5 }}>
        <Button sx={{ width: '50%' }} onClick={handleBack}>
          {t('back')}
        </Button>
        <Button disabled={!notEmpty(password, validPassword) || password !== repeatedPassword} sx={{ width: '50%' }} variant="contained" color="primary" onClick={handleNext}>
          {t('continue')}
        </Button>
      </Stack>
    </Box>
  );
}
